import { createContext, useState, useEffect } from "react";

export const FormContext = createContext<any>({});

type FormProps = {
  children: React.ReactNode; //👈 children prop type
};

export const FormProvider = ({ children }: FormProps) => {
  const [personalInfo, setPersonalInfo] = useState({});
  const [groupInfo, setGroupInfo] = useState({});
  const [productInfo, setProductInfo] = useState({});
  const [policyInfo, setPolicyInfo] = useState({});
  const [coveredProductInfo, setCoveredProductInfo] = useState({});
  const [coveredLive, setCoveredLive] = useState({
    CoveredName: "",
    CoveredSurname: "",
    CoveredIdNumber: "",
    CoveredDateOfBirth: "",
    CoveredAmount: "",
    CoveredType: "",
    ExtendedProduct: ""
  });

  return (
    <FormContext.Provider
      value={{
        personalInfo,
        setPersonalInfo,
        groupInfo,
        setGroupInfo,
        productInfo,
        setProductInfo,
        policyInfo,
        setPolicyInfo,
        coveredProductInfo,
        setCoveredProductInfo,
        coveredLive,
        setCoveredLive,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
